import { render, staticRenderFns } from "./NoticeCard.vue?vue&type=template&id=1637855f&"
import script from "./NoticeCard.vue?vue&type=script&lang=js&"
export * from "./NoticeCard.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports